<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  background: linear-gradient(0deg, #0A0D11 0%, #120D28 100%);
}

.bg-active {
  background: linear-gradient(90deg, #7204FD 0%, #0940FF 100%) !important;

  /* background: linear-gradient(90deg, #0940FF 0%, #4604B5 100%) !important; */
  color: white !important;
}

.bg-active-light {
  background: linear-gradient(90deg, #DC5CA6 0%, #4B07B5 100%) !important;
  color: white !important;
}

.active-color {
  color: white !important;
}

.text-active-color {
  background: linear-gradient(90deg, #FFFFFF 0%, #F2B0D2 50%, #4B07B4 100%);
  /* 水平红→绿渐变 */
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.tabbar-box {
  z-index: 12345 !important;
  background: #00000069 !important;
  border-top: none !important;
}

.dd-glass {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);
}

.custom-button {
  background-color: white !important;
  color: black !important;
  font-family: mozillaplayr-regular !important;
  text-align: center;
  font-size: 14px;
}

.custom-button.disabled {
  background-color: #ffffff18 !important;
  color: #fff !important;
}

.bg-white {
  background-color: white !important;
}

.transparent-video {
  mix-blend-mode: screen;
  /* 关键属性 */
}

.ai-loading {
  position: fixed !important;
  z-index: 123313 !important;
  top: 50% !important;
  left: 50% !important;
  margin-left: -20px !important;
}
</style>
